import React from 'react';
import { useParams } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import ReviewContainer from '../../components/client/review-submit/review-container';
import { useTranslation } from 'react-i18next';

/**
 * Page de soumission d'avis client via un lien avec token
 */
const ReviewSend: React.FC = observer(() => {
  const { t } = useTranslation();
  const { token } = useParams<{ token: string }>();
  
  return (
    <div className="min-h-screen bg-gradient-to-br from-white via-primary/5 to-white relative overflow-hidden">
      {token ? (
        <ReviewContainer token={token} />
      ) : (
        <p>{t('reviews.missingToken')}</p>
      )}
    </div>
  );
});

export default ReviewSend;
